<template>
  <div class="mt-2">
    <v-autocomplete
      v-model="selection"
      :loading="loading"
      :items="items"
      item-text="diagnosis"
      :menu-props="{ contentClass: 'icd-autocomplete' }"
      :search-input.sync="search"
      persistent-hint
      clearable
      flat
      no-filter
      hide-no-data
      :label="label"
      @change="setSelected"
      @click:clear="clearFilters"
    >
      <template v-slot:item="data">
        <template>
          <span class="my-1">
            {{ data.item.diagnosis }}
          </span>
        </template>
      </template>
    </v-autocomplete>
    <div v-if="selected && filteredResults.length > 0">
      <span class="caption grey--text text--darken-1">Orgão/Sistema</span>

      <div>
        <v-autocomplete
          v-model="selectedGroup"
          class="mt-0 pt-0"
          :items="group"
          dense
          clearable
          single-line
        />
      </div>

      <template v-if="selectedGroup === 'Tecidos Hematopoiéticos e Linfóides'">
        <span
          v-if="hematology_organ.length > 0"
          class="caption grey--text text--darken-1"
          >Orgao Hematologico</span
        >
        <p v-if="hematology_organ.length === 1">
          {{ filteredResults[0].hematology_organ }}
        </p>
        <div v-else-if="hematology_organ.length > 1">
          <v-select
            class="mt-0 pt-0"
            :items="hematology_organ"
            dense
            clearable
            single-line
            v-model="selectedHematologyOrgan"
          />
        </div>
      </template>

      <span class="caption grey--text text--darken-1">Categoria Principal</span>
      <p v-if="category.length === 1">{{ filteredResults[0].category }}</p>
      <div v-else-if="category.length > 1">
        <v-select
          class="mt-0 pt-0"
          :items="category"
          dense
          clearable
          single-line
          @change="filterResults($event, 'categoryFilter')"
        />
      </div>

      <span class="caption grey--text text--darken-1">Grupo Morfológico</span>
      <p v-if="type.length === 1">{{ filteredResults[0].type }}</p>
      <div v-else-if="type.length > 1">
        <v-select
          class="mt-0 pt-0"
          :items="type"
          dense
          clearable
          single-line
          @change="filterResults($event, 'typeFilter')"
        />
      </div>

      <span v-if="subtype.length > 0" class="caption grey--text text--darken-1"
        >Grupo Morfológico II</span
      >
      <p v-if="subtype.length === 1">{{ filteredResults[0].subtype }}</p>
      <div v-else-if="subtype.length > 1">
        <v-select
          class="mt-0 pt-0"
          :items="subtype"
          dense
          clearable
          single-line
          @change="filterResults($event, 'subtypeFilter')"
        />
      </div>

      <div v-if="userSpeciality === 'pathology'">
        <span v-if="this.filteredResults[0].tumoral">Patologia Tumoral</span>
        <span v-else>Patologia Adicional</span>
      </div>

      <div style="text-align: right">
        <v-btn
          v-if="filteredItems.length > 1"
          :disabled="isAnyFilterActive()"
          @click="clearFilters"
          class="mr-0 mb-3"
          depressed
          small
          color="secondary"
        >
          editar opções
        </v-btn>
        <v-btn
          :disabled="filteredResults.length > 1"
          @click="addValue"
          class="mr-0 mb-3"
          depressed
          small
          color="primary"
        >
          adicionar
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import * as algolia from '../../services/algolia.js'
import { Option } from '../../models/Specialty'
export default {
  props: {
    diagnosis: { default: null },
    label: { type: String, default: 'Pesquisa de diagnóstico' },
    searchIndex: { type: String, default: 'pathology_diagnoses' }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      selected: false,
      filteredItems: [],
      selection: '',
      groupFilter: null,
      categoryFilter: null,
      typeFilter: null,
      subtypeFilter: null,
      selectedGroup: null,
      selectedHematologyOrgan: null
    }
  },
  computed: {
    userSpeciality() {
      return this.$store.getters.specialty
    },
    filteredResults() {
      let items = [...this.filteredItems]

      // if (this.groupFilter) {
      //  items = items.filter(item => item.group === this.groupFilter)
      // }

      if (this.categoryFilter) {
        items = items.filter(item => item.category === this.categoryFilter)
      }
      if (this.typeFilter) {
        items = items.filter(item => item.type === this.typeFilter)
      }
      if (this.subtypeFilter) {
        items = items.filter(item => item.subtype === this.subtypeFilter)
      }

      return items
    },
    group() {
      const groupOptions = Option.query()
        .where('component', 'pathology-diagnosis')
        .get()

      return groupOptions.map(o => o.text).sort()
      // let group = this.filteredResults.map(item => item.group).filter(Boolean)
      // group = [...new Set(group)]
      // return group
    },
    category() {
      let category = this.filteredResults
        .map(item => item.category)
        .filter(Boolean)
      category = [...new Set(category)]
      return category
    },
    type() {
      let type = this.filteredResults.map(item => item.type).filter(Boolean)
      type = [...new Set(type)]
      return type
    },
    subtype() {
      let subtype = this.filteredResults
        .map(item => item.subtype)
        .filter(Boolean)
      subtype = [...new Set(subtype)]
      return subtype
    },
    hematology_organ() {
      return ['Medula óssea', 'Gânglio linfático', 'Baço']
    }
  },
  watch: {
    search(val) {
      if (val && val !== this.selection) {
        this.fetchItems(val)
      }
    }
  },
  methods: {
    async fetchItems(query = '') {
      if (!query.trim()) {
        return
      }
      this.loading = true
      let filters = {}
      if (this.$store.getters.specialty === 'oncology') {
        filters = { tumoral: true }
      } else {
        filters = { tumoral: false }
      }

      try {
        const data = await algolia.search(
          query,
          this.searchIndex,
          this.$store.getters.accessToken,
          filters
        )

        this.items = data
      } catch (err) {
        console.error(err)
        this.$store.dispatch('showErrorSnackbar', 'Algo deu errado')
      }
      this.loading = false
    },
    async setSelected() {
      this.clearFilters()
      this.search = this.selection
      await this.fetchItems(this.search)
      const result = this.items.filter(item => {
        return item.diagnosis && item.diagnosis.includes(this.selection)
      })

      this.selected = true
      this.filteredItems = result
    },
    filterResults(value, key) {
      this[key] = value
    },
    clearFilters() {
      this.groupFilter = null
      this.categoryFilter = null
      this.typeFilter = null
      this.subtypeFilter = null
    },
    isAnyFilterActive() {
      if (
        this.groupFilter ||
        this.categoryFilter ||
        this.typeFilter ||
        this.subtypeFilter
      ) {
        return false
      }
      return true
    },
    addValue() {
      const selectedDiagnosis = this.filteredResults[0]
      selectedDiagnosis.group = this.selectedGroup
      selectedDiagnosis.hematologyOrgan = this.selectedHematologyOrgan
      this.$emit('update:diagnosis', selectedDiagnosis)
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
